module.exports = __webpack_public_path__ + "static/media/logo-selecthealth-cobrand-color.3057dec5.svg";